import React from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'
import Link from 'next/link'
import config from 'SRC/config/config.yaml'

export const Item = ({ id, title, iconSvg, href, as, isActive }) => {
  const activeItemRef = React.useRef(null)

  React.useEffect(() => {
    const container = document.querySelector('.category-horizontal-menu-mobile-items')
    if (activeItemRef && activeItemRef.current && container) {
      container.scrollTo(activeItemRef.current.offsetLeft, 0)
    }
  })

  return !isActive ? (
    <Link href={href} as={as}>
      <a className='category-horizontal-menu-mobile-item'>
        {iconSvg ? (
          <ReactSVG
            src={`${config.mediaCDN}${iconSvg}`}
            beforeInjection={svg => {
              svg.setAttribute('style', 'width: 40px; max-height: 40px;')
            }}
            wrapper='span'
            className='svg-container'
          />
        ) : null}
        <p>{title}</p>
      </a>
    </Link>
  ) : (
    <a className='category-horizontal-menu-mobile-item  active' href='javascript:void(0)' ref={activeItemRef}>
      {iconSvg ? (
        <ReactSVG
          src={`${config.mediaCDN}${iconSvg}`}
          beforeInjection={svg => {
            svg.setAttribute('style', 'width: 40px; max-height: 40px;')
          }}
          wrapper='span'
          className='svg-container'
        />
      ) : null}
      <p>{title}</p>
    </a>
  )
}

Item.propTypes = {
  id: PropTypes.number.isRequired,
  iconSvg: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  href: PropTypes.shape({
    pathname: PropTypes.string,
    query: PropTypes.object
  }).isRequired,
  as: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired
}
